import React, { useState } from "react";
import ReactCardFlip from "react-card-flip";
import "./Cards.css";
import FloatingPanel from "./FloatingPanel";

export default function Cards({ frontSide, backSide, code }) {
  const [flipped, setFlipped] = useState(false);
  const [codeShow, setCodeShow] = useState(false);

  return (
    <div>
      <ReactCardFlip isFlipped={flipped} flipDirection="horizontal">
        <div
          className="card-boarder"
          style={{
            background:
              "linear-gradient(350deg, rgb(247 200 205) 0%, rgb(255, 239, 255) 51%, rgb(252, 233, 255) 51%, rgb(255, 255, 255) 100%)",
          }}
        >
          <h3 className="rotate" style={{ textDecoration: "underline",  }}>
            {frontSide}
          </h3>

          <button
            className="btn btn-secondary"
            onClick={() => setFlipped((prevState) => !prevState)}
          >
            Flip
          </button>
        </div>

        <div className="card-boarder" style={{ backgroundColor: "#d4d3da" }}>
          <div>
            <p style={{ textAlign: "justify" }}>
              {!(backSide instanceof Array)
                ? backSide
                : backSide.map((item, index) => <li key={index}> {item} </li>)}
            </p>
          </div>
          <div>
            {code ? (
              <button
                className="btn btn-info"
                style={{ left: "60px" }}
                onClick={() => setCodeShow((prev) => !prev)}
              >
                Code sample
              </button>
            ) : (
              ""
            )}
            {codeShow ? (
              <FloatingPanel code={code} updateCodeSampleClick={setCodeShow} />
            ) : (
              ""
            )}
            <button
              className="btn btn-danger"
              onClick={() => setFlipped((prevState) => !prevState)}
            >
              Close
            </button>
          </div>
        </div>
      </ReactCardFlip>
    </div>
  );
}
